// extracted by mini-css-extract-plugin
export default {"card":"ShareCta_card__FQ3Y5","btnWrapper":"ShareCta_btnWrapper__4+E1z"};